import { call, put, select } from 'redux-saga/effects';
import {
	setProducts,
	getProductsFail,
	setProduct,
} from '../../ducks/productSlice';
import {
	requestGetProducts,
	requestGetProduct,
	requestGetProductsTotal,
} from '../requests/products';
export const getProducts = (state) => state.products;

export function* handleGetProducts(action) {
	try {
		const product = yield select(getProducts);
		if (product.filters) {
			const response = yield call(requestGetProducts, product.filters);
			const { data } = response;
			let filter = {};
			if (data.success) {
				filter = {
					// total: data.records.total,
					// totalpages: data.records.totalpages,
				};
			}
			yield put(setProducts({ ...data, filters: filter, productsLoading: false }));
		}
	} catch (error) {
		yield put(
			getProductsFail({ message: error.message, response: error.response })
		);
	}
}
export function* handleGetProductTotal(action) {
	try {
		const product = yield select(getProducts);
		if (product.filters) {
			const response = yield call(requestGetProductsTotal, product.filters);
			let filter = {};
			const { data } = response;
			if (data.success) {
				const total = data.records.total;
				// get total pages
				const totalpages = Math.ceil(total / product.filters.showitems);

				filter = {
					ourStock: data.records.ourStock,
					supplierStock: data.records.supplierStock,
					outofStock: data.records.outofStock,
					maxprice: parseInt(data.records.maxprice),
					total: data.records.total,
					totalpages: totalpages,
				};
			}
			yield put(setProducts({ totalLoading: false, filters: filter }));
		}
	} catch (error) {
		yield put(
			getProductsFail({ message: error.message, response: error.response })
		);
	}
}
export function* handleGetProduct(action) {
	try {
		if (action.payload) {
			const response = yield call(requestGetProduct, action.payload);
			const { data } = response;
			yield put(setProduct({ ...data }));
		}
	} catch (error) {
		yield put(
			getProductsFail({ message: error.message, response: error.response })
		);
	}
}
